import { Status as t } from "../../../../../../../common/shared/status.js";
import { Adapter as g } from "../../../../adapter.js";
import { KioskConfigurationCommonModel as u } from "./kioskConfigurationCommon.model.js";
class b extends g {
  adapt(o) {
    var n, s, r, i;
    return new u({
      design: {
        colors: {
          text: o.design.colors.text,
          buttonText: o.design.colors.button_text,
          secondaryButtonBackground: o.design.colors.secondary_button_background,
          secondaryButtonText: o.design.colors.secondary_button_text,
          backgroundProduct: o.design.colors.background_product,
          backgroundMain: o.design.colors.background_main,
          line: o.design.colors.line,
          buttonBackground: o.design.colors.button_background
        },
        fontFamily: o.design.font_family
      },
      settings: {
        status: ((n = o == null ? void 0 : o.settings) == null ? void 0 : n.status) ?? t.DISABLED,
        bodyCode: ((s = o == null ? void 0 : o.settings) == null ? void 0 : s.body_code) ?? "",
        headCode: ((r = o == null ? void 0 : o.settings) == null ? void 0 : r.head_code) ?? "",
        supportedLanguages: ((i = o == null ? void 0 : o.settings) == null ? void 0 : i.supported_languages) ?? [],
        shopUrl: o.settings.shop_url,
        location: o.settings.location,
        menus: (o.settings.menus ?? []).map((e) => ({
          serviceType: e.service_type,
          ids: e.ids,
          language: e.language
        })),
        timezone: o.settings.timezone
      }
    });
  }
  serialize(o) {
    throw new Error("Method not implemented.");
  }
}
export {
  b as KioskConfigurationCommonAdapter
};
//# sourceMappingURL=kioskConfigurationCommon.adapter.js.map
